import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as S from "./styles";
import FormRegister from '../../Components/FormRegister';

import promoLogo from '../../assets/img/promoLogo.png';

function Cadastro() {

    return (
        <S.Container>
            <section className="relative bg-primary overflow-hidden">
                <div className="relative container max-w-large">
                    <img src={promoLogo} alt="Logo da promoção" className="mx-auto w-[160px] sm:w-[200px] 2xl:w-[250px] pt-24 sm:pt-40 2xl:pt-44 pb-8 sm:pb-12 brightness-0 invert pointer-events-none" />

                    <h3 className="font-secondary-xt text-4xl 2xl:text-[45px] text-tertiary text-center font-semibold mb-2">cadastro</h3>
                    <p className="text-lg text-white text-center mb-4">Preencha os campos abaixo com os respectivos dados solicitados.</p>
                    
                    <FormRegister/>
                </div>
            </section>
        </S.Container>
    );
}

export default Cadastro;